import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { css, useTheme } from '@emotion/react';
import { PAGE_ROUTE } from '~/constants';
import MotionList from './MotionList/MotionList';
import TabMenu from './TabMenu/TabMenu';

export type AssetMotionTab = 'BodyShape' | 'Clothes' | 'Hair';

export default function Motion() {
  const navigate = useNavigate();
  const theme = useTheme();

  const [selectedTab, setSelectedTab] = useState<AssetMotionTab>('BodyShape');

  const handleTabChange = (tab: AssetMotionTab) => {
    setSelectedTab(tab);
    if (tab !== 'BodyShape') {
      handleSubscriptionClick();
    }
  };

  const handleSubscriptionClick = () => {
    navigate(PAGE_ROUTE.SUBSCRIPTION);
  };

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        height: calc(100% - ${theme.layout.assetStore_canvas_height});
        padding: 0 ${theme.layout.section_side};
      `}
    >
      <TabMenu selectedTab={selectedTab} handleTabChange={handleTabChange} />
      {selectedTab === 'BodyShape' && (
        <MotionList handleSubscriptionClick={handleSubscriptionClick} />
      )}
    </div>
  );
}
